// Tracks whether the visitor has already been shown the "you can get notified"
// announcement.
//
// The key is versioned on purpose. Gating on the existing `visitor_counted` flag
// would mean nobody who has ever loaded the site could learn about a new feature,
// and a bare `intro_seen` would block every future announcement too. Bumping the
// version is how a later announcement gets shown again.
const INTRO_KEY = "notify_intro_seen_v1";

export function hasSeenNotifyIntro() {
  try {
    return localStorage.getItem(INTRO_KEY) === "true";
  } catch {
    // Private browsing / storage disabled: treat as seen so we never nag someone
    // we can't remember dismissing it.
    return true;
  }
}

export function markNotifyIntroSeen() {
  try {
    localStorage.setItem(INTRO_KEY, "true");
  } catch {
    // Nothing useful to do; the dialog just reappears next visit.
  }
}
